import { apiClient } from '@/shared/api/apiClient';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { VisitHistoryParams, VisitHistoryResponse } from '../model';
import { normalizeIdentityType } from '@/entities/mfa-identity';

const getVisitHistory = async (
  params?: VisitHistoryParams,
  options?: RequestHandlerOptions
) => {
  const nextFrameId = params?.nextFrameId ?? undefined;
  const queryString = nextFrameId ? `?nextFrameId=${nextFrameId}` : '';

  const request = () => apiClient.get(`/users/profile/activity${queryString}`);
  const response = await handleRequest<VisitHistoryResponse>(request, options);
  return {
    ...response.data,
    activities: response.data.activities.map(activity => ({
      ...activity,
      identityType: activity.identityType
        ? normalizeIdentityType(activity.identityType)
        : activity.identityType,
    })),
  };
};

export { getVisitHistory };
